export const styles = () => {
  return {
    chipGroupContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 12,
    } as React.CSSProperties,
  };
};
